'use client';

import {
  ArrowsRightLeftIcon,
  MapPinIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';
import { clearCart, setRelatedCartItems } from '@/redux/slices/cart.slice';
import {
  getRandomInt,
  getRelatedProducts,
  getUserLocation,
  mapItemsByCategory,
} from '@/utils/helpers';
import {
  hydrateUserLocation,
  updateUserLocation,
} from '@/redux/slices/userLocation.slice';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import AppStorage from '@/utils/helpers';
import { BounceLoader } from 'react-spinners';
import { GetOutletMenusForCustomer } from '@/services/menu.api';
import { GetOutletsAroundMe } from '@/services/order.api';
import LocationInput from '@/components/global/LocationInput';
import MenuItemCard from '@/components/menu/MenuItemCard';
import Modal from '@/components/global/Modal';
import OrderType from '@/components/global/OrderType';
import PageContainer from '@/components/global/page-container';
import { toast } from 'react-toastify';
import CategoryReducer, { addToOutlet } from '@/redux/slices/category.slice';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import LocationDetails from '@/components/global/LocationDetails';
import LocationWarning from '@/components/global/LocationWarning';
import LoadingModal from '@/components/global/LoadingModal';

export default function MenuPage() {
  const { outlet } = useAppSelector((state) => state.category);
  const { orderType: orderCategory } = useAppSelector(
    (state: any) => state.checkout
  );
  const dispatch = useAppDispatch();
  const [outlets, setOutlets] = useState([]);
  const [outletMenu, setOutletMenu] = useState<any>({});
  const [activeCategory, setActiveCategory] = useState(0);
  const [showLocationAfterOrderType, setShowLocationAfterOrderType] =
    useState(false);
  const [viewModal, setViewModal] = useState({
    location: false,
    outlet: false,
    orderType: false,
  });
  const [loading, setLoading] = useState(false);
  const { cart } = useSelector((state: any) => state.cart);
  const location = useSelector((state: any) => state.userLocation.location);
  const [orderType, setOrderType] = useState<string | null>(null);
  const [state, setState] = useState('');
  const [city, setCity] = useState('');
  const [branch, setBranch] = useState('');
  const [branches, setBranches] = useState<
    {
      _id: string;
      name: string;
      city: string;
      state: string;
      location: { coordinates: [number, number] };
    }[]
  >([]);
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const [mounting, setMounting] = useState<boolean>(true);

  const storedOrderType = AppStorage.get('orderType') as string;
  useEffect(() => {
    AppStorage.remove('orderId');
    const storedLocation = JSON.parse(AppStorage.get('location') as string);

    if (storedLocation && storedLocation !== undefined) {
      dispatch(hydrateUserLocation(storedLocation));
    }

    setOrderType(storedOrderType);
    setActiveCategory(Number(AppStorage.get('activeCategory') || 0));

    if (!storedLocation || storedLocation === undefined) {
      setMounting(false);
      setViewModal((prev) => ({ ...prev, location: true }));
    }
    if (!storedOrderType && storedLocation && storedLocation !== undefined) {
      setMounting(false);
      setViewModal((prev) => ({ ...prev, orderType: true }));
    }
  }, [dispatch]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (location && orderType) {
          setMounting(false);
          setLoading(true);
          const nearbyOutlets = await GetOutletsAroundMe(
            location.lat,
            location.lng
          );

          setOutlets(nearbyOutlets);

          // if (nearbyOutlets.length) {
          // const selectedOutlet = nearbyOutlets[0];
          // dispatch(addToOutlet(selectedOutlet));

          const menuContent = await GetOutletMenusForCustomer(outlet?._id);
          const categorizedMenu = mapItemsByCategory(menuContent);
          setOutletMenu(categorizedMenu);
          // } else {
          //   AppStorage.save('outlet', JSON.stringify({}));
          // }
        }
      } catch (error) {
        toast.error('Failed to fetch outlets or menu');
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [location, orderType, dispatch]);

  const handleOrderTypeSelection = () => {
    const newOrderType = AppStorage.get('orderType') as string;
    setOrderType(newOrderType);
    // if (showLocationAfterOrderType) {
    //   setShowLocationAfterOrderType(false);
    // } else {
    //   setViewModal((prev) => ({ ...prev, location: false }));
    // }
  };

  const handleLocation = () => {
    const selectedBranch = branches.find(
      (branchObj: any) => branchObj.name === branch
    );
    dispatch(addToOutlet(selectedBranch));

    const location = {
      id: selectedBranch?._id ?? '',
      address: selectedBranch?.name ?? '',
      street: '',
      city: selectedBranch?.city ?? '',
      name: selectedBranch?.city ?? '',
      state: selectedBranch?.state ?? '',
      lat: selectedBranch?.location?.coordinates[1] ?? 0,
      lng: selectedBranch?.location?.coordinates[0] ?? 0,
    };

    dispatch(hydrateUserLocation(location));
    AppStorage.save('location', JSON.stringify(location));
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const catParam = urlParams.get('cat')?.toLowerCase();
    if (catParam) {
      const categoryIndex = Object.keys(outletMenu).findIndex(
        (category) => category === catParam
      );
      if (categoryIndex !== -1) {
        setActiveCategory(categoryIndex);
        AppStorage.save('activeCategory', categoryIndex.toString());
      }
    }
  }, [outletMenu]);

  if (loading || mounting) {
    return (
      <LoadingModal
        isOpen
        title={mounting ? '' : 'Menu is loading'}
        message="Please wait..."
      />
    );
  }

  return (
    <PageContainer pageTitle="Our Menu" pageDesc={`${outlet?.name}`}>
      <section className="w-full max-w-[1440px] mx-auto">
        <Modal
          modalTitle="Start here"
          openModal={viewModal.location}
          closeModal={() =>
            setViewModal((prev) => ({ ...prev, location: false }))
          }
          shouldCloseOnOverlayClick={false}
          closeButton={false}
        >
          {!location && (
            // <LocationInput />
            <LocationDetails
              setState={setState}
              state={state}
              setCity={setCity}
              city={city}
              setBranch={setBranch}
              branch={branch}
              setBranches={setBranches}
              setShowWarning={setShowWarning}
            />
          )}
          {!orderType && <OrderType />}
          <button
            disabled={!state || !city || !branch || !orderCategory}
            className={`text-white flex gap-2 items-center shadow px-5 py-3 w-max mx-auto rounded-full ${!state || !city || !branch || !orderCategory ? 'bg-gray-300' : 'bg-crunchies-red'}`}
            onClick={() => {
              if (!location) {
                // const newLocation = JSON.parse(
                //   AppStorage.get('location') as string
                // );
                // dispatch(updateUserLocation(newLocation));
                handleLocation();
                handleOrderTypeSelection();
              }
              setViewModal((prev) => ({ ...prev, location: false }));
              // if (!orderType) {
              //   setViewModal((prev) => ({ ...prev, orderType: true }));
              // }
            }}
          >
            <RocketLaunchIcon className="w-6" />
            <div>Let&apos;s go!</div>
          </button>
        </Modal>

        <Modal
          modalTitle="Choose your order type"
          openModal={viewModal.orderType}
          closeModal={() =>
            setViewModal((prev) => ({ ...prev, orderType: false }))
          }
          shouldCloseOnOverlayClick={false}
          closeButton={false}
        >
          <OrderType />
          <button
            disabled={!orderCategory}
            className={`text-white flex gap-2 items-center shadow px-5 py-3 w-max mx-auto rounded-full ${!orderCategory ? 'bg-gray-300' : 'bg-crunchies-red'}`}
            onClick={() => {
              if (!orderType) {
                handleOrderTypeSelection();
              }
              setViewModal((prev) => ({ ...prev, orderType: false }));
            }}
          >
            <RocketLaunchIcon className="w-6" />
            <div>Let&apos;s go!</div>
          </button>
        </Modal>

        <Modal
          openModal={showWarning}
          closeModal={() => setShowWarning(false)}
          modalTitle=""
          closeButton={true}
          shouldCloseOnOverlayClick={true}
        >
          <LocationWarning />
        </Modal>

        {location && orderType && !loading && !mounting && !outlet ? (
          <div className="flex flex-col gap-10 items-center justify-center h-[70vh]">
            <p>Sorry, there are no nearby outlets.</p>
            <button
              className="text-white flex gap-2 items-center bg-crunchies-red shadow px-5 py-3 w-max mx-auto rounded-full"
              onClick={() => {
                AppStorage.remove('location');
                dispatch(updateUserLocation(null));
                setViewModal((prev) => ({ ...prev, location: true }));
              }}
            >
              <MapPinIcon className="w-6" />
              <div className="text-xs">Choose a different location</div>
            </button>
          </div>
        ) : (
          <>
            <div className="px-5 grid gap-5 md:flex items-center">
              <div>
                <p className="grid grid-cols-3 md:flex gap-2 text-xs">
                  <span className="text-gray-500">Ordering from:</span>
                  <span className="font-bold col-span-2">{outlet?.name}</span>
                </p>
                <p className="grid grid-cols-3 md:flex gap-2 text-xs">
                  <span className="text-gray-500">Outlet&apos;s address:</span>
                  <span className="col-span-2">{outlet?.address}</span>
                </p>
              </div>

              <div>
                <button
                  className="text-xs py-3 px-5 rounded-full bg-crunchies-red text-crunchies-white font-bold"
                  onClick={() =>
                    setViewModal((prev) => ({ ...prev, outlet: true }))
                  }
                >
                  Change Outlet
                </button>

                <Modal
                  modalTitle="Choose a different outlet"
                  closeModal={() =>
                    setViewModal((prev) => ({ ...prev, outlet: false }))
                  }
                  openModal={viewModal.outlet}
                  shouldCloseOnOverlayClick={true}
                >
                  {outlets?.map((outlet: any, index: number) => (
                    <button
                      className="shadow-lg text-left p-5 flex items-center justify-between gap-5"
                      key={index}
                      onClick={() => {
                        dispatch(addToOutlet(outlet));
                        dispatch(clearCart());
                        toast.warn(
                          'You have chosen a different outlet. Cart cleared'
                        );
                        setViewModal((prev) => ({ ...prev, outlet: false }));
                      }}
                    >
                      <div>
                        <p className="font-bold">{outlet?.name}</p>
                        <p>{outlet?.address}</p>
                      </div>

                      <ArrowsRightLeftIcon className="w-6" />
                    </button>
                  ))}
                </Modal>
              </div>
            </div>

            <div className="px-5 py-3 grid grid-cols-3 md:flex md:gap-10 justify-start items-center sticky top-0 bg-crunchies-white z-[5]">
              {Object.keys(outletMenu).map((item: any, index: number) => (
                <button
                  key={index}
                  onClick={() => {
                    AppStorage.save('activeCategory', index.toString());
                    setActiveCategory(index);
                  }}
                  className="py-2 w-max uppercase text-xs"
                >
                  <div className="w-4 h-1 rounded-full mx-auto bg-crunchies-white" />
                  <div className="mb-1">{item}</div>
                  <div
                    className={`w-4 h-1 rounded-full mx-auto ${
                      index === activeCategory
                        ? 'bg-crunchies-red'
                        : 'bg-crunchies-white'
                    }`}
                  />
                </button>
              ))}
            </div>

            <div className="p-5 grid gap-5 grid-cols-2 md:gap-10 lg:grid-cols-4">
              {outletMenu[Object.keys(outletMenu)[activeCategory]]?.map(
                (item: any, index: number) => (
                  <MenuItemCard key={index} menuItem={item} />
                )
              )}
            </div>
          </>
        )}
      </section>
    </PageContainer>
  );
}
